import { jsx as e } from "react/jsx-runtime";
function l(L) {
  return /* @__PURE__ */ e("svg", { height: "16", viewBox: "0 0 14 16", width: "14", ...L, children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M6.64645 0.646444L3.46447 3.82843C3.2692 4.02369 3.2692 4.34027 3.46447 4.53553C3.65973 4.73079 3.97631 4.73079 4.17157 4.53553L6.5 2.2071L6.5 10H7.5L7.5 2.2071L9.82843 4.53553C10.0237 4.73079 10.3403 4.73079 10.5355 4.53553C10.7308 4.34027 10.7308 4.02369 10.5355 3.82843L7.35355 0.646444C7.15829 0.451182 6.84171 0.451182 6.64645 0.646444ZM0 4.92315V15.0001V16.0001V16.0001H1V16.0001H13L13 16.0001H14L14 4.92315H13L13 15.0001H1L1 4.92315H0Z",
      fill: "#052643",
      fillRule: "evenodd"
    }
  ) });
}
export {
  l as default
};
